import type { ZoneMatchVariant } from 'utils/zone-match-labels';

// Text color per Size Match variant, shared by every surface that prints a
// match label so a PTAC unit and a ducted zone read the same way. Only a
// match inside the band reads as good; either side of it is a caution, and
// the outright tiers a warning.
export const MATCH_TEXT_CLASS: Record<ZoneMatchVariant, string> = {
  perfect: 'text-emerald-700',
  over: 'text-yellow-500',
  oversized: 'text-orange-600',
  slightlyUnder: 'text-yellow-500',
  under: 'text-orange-600',
  unknown: 'text-gray-400'
};
